export default __webpack_public_path__ + "static/thumbnail-c05883c66c5ae597d806474f547ce5cf.png";